"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const uuid_1 = require("uuid");
const noop_1 = __importDefault(require("lodash/noop"));
const react_dropzone_1 = __importDefault(require("react-dropzone"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
const CloudUpload_1 = __importDefault(require("@mui/icons-material/CloudUpload"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const core_1 = require("companion-app-components/utils/core");
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const actions = __importStar(require("companion-app-components/flux/documents/documentsActions"));
const documentSelectors = __importStar(require("companion-app-components/flux/documents/documentsSelectors"));
const documentsTypes_1 = require("companion-app-components/flux/documents/documentsTypes");
const actions_1 = require("data/apiUtil/actions");
const styledComponents_1 = require("./styledComponents");
const styles_1 = require("./styles");
const log = (0, core_1.getLogger)('components/AddAndBrowseDocuments/index.tsx');
const { MAX_TX_ATTACHMENTS } = documentSelectors;
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
/* TODO
Word of caution when working with previews

  Important: react-dropzone doesn't manage dropped files. You need to destroy the object URL yourself
  whenever you don't need the preview by calling window.URL.revokeObjectURL(file.preview); to avoid memory leaks.
  Support
*/
const UNAVAILABLE = 'unavailable';
const UNAVAILABLE_NAME = '-unavailable-';
const AddAndBrowseDocuments = (props) => {
    const [images, setImages] = (0, react_1.useState)([]);
    const [imagesLoading, setImagesLoading] = (0, react_1.useState)([]);
    const [sizeChanged, setSizeChanged] = (0, react_1.useState)(false);
    const [forceRender, setForceRender] = (0, react_1.useState)(false);
    const accepted = (0, react_1.useRef)([]);
    const checkRecordsCount = (0, react_1.useRef)(0);
    const txnAttachments = (0, react_1.useRef)(props.txn.attachments || []);
    const { classes } = useStyle();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const documents = (0, react_redux_1.useSelector)((state) => documentSelectors.getDocuments(state));
    const reqReturn = ({ err, data, id, document }) => {
        if (err) {
            log.log(err, 'error');
            // error 400 means the docID has been deleted
            if (!err.response || err.response.status === 400) {
                setImages((prevImages) => [
                    ...prevImages,
                    { id, url: UNAVAILABLE, name: UNAVAILABLE_NAME, document },
                ]);
                setSizeChanged(true);
            }
        }
        else {
            setImages((prevImages) => {
                if (!prevImages.find((item) => item.id === id)) {
                    return [...prevImages, { id, url: data.data.url, document }];
                }
                return prevImages;
            });
            setSizeChanged(true);
        }
    };
    const processProps = () => {
        log.log('Process Props', props, images);
        const currentImages = images || [];
        const newImages = [];
        if (props.txn.attachments && props.txn.attachments.length > 0) {
            props.txn.attachments.forEach((docObj) => {
                const document = documents.find((x) => x.id === docObj.id);
                const alreadyHere = currentImages.find((x) => x.id === docObj.id);
                if (document && !alreadyHere) {
                    const path = `documents/${docObj.id}/original`;
                    const obj = {
                        reqId: docObj.id,
                        path,
                        data: null,
                        verb: 'get',
                        cb: (err, data, id) => reqReturn({ err, data, id, document }),
                    };
                    log.log('Make API Call to:', obj);
                    dispatch((0, actions_1.makeQCSApiCall)(obj));
                }
                else if (alreadyHere) {
                    newImages.push(alreadyHere);
                }
                else {
                    newImages.push({ id: docObj.id, url: UNAVAILABLE, name: UNAVAILABLE_NAME, document });
                    setSizeChanged(true);
                }
            });
        }
        setImages(newImages);
    };
    (0, react_1.useEffect)(() => {
        processProps();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.txn.attachments]);
    (0, react_1.useEffect)(() => {
        if (sizeChanged) {
            setSizeChanged(false);
            if (props.onSizeChange) {
                props.onSizeChange();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sizeChanged]);
    const fileSent = (err, data, reqObj) => {
        if (err) {
            dialogAlert('Error saving an attachment', `Error: ${err}`, noop_1.default, ['Got it']);
        }
        else {
            // need id, url, document
            log.log('File Sent ', reqObj);
            // @ts-expect-error: Argument of type 'DocumentType[]' is not assignable to parameter of type 'ConcatArray<never>'.
            const attachments = [].concat(txnAttachments.current || []);
            attachments.push({ id: reqObj.id });
            txnAttachments.current.push({ id: reqObj.id });
            props.onChange(attachments);
            setImagesLoading((prevImagesLoading) => prevImagesLoading.filter((x) => x.document.clientId !== reqObj.document.clientId));
        }
    };
    const updateFn = (doc, file) => {
        const data = {
            reqId: { id: doc.id, clientId: doc.clientId, name: file.name, document: doc },
            path: doc.url,
            callData: file,
            verb: 'put',
            cb: fileSent,
            headers: { 'Content-Type': doc.contentType },
        };
        log.log(`Sending File for ${file.name}`, data);
        dispatch((0, actions_1.makeGeneralApiCall)(data));
    };
    const checkRecords = (restart = false) => {
        checkRecordsCount.current = restart ? 0 : checkRecordsCount.current + 1;
        log.log('Add Document: checking records', accepted.current, checkRecordsCount.current);
        const newAccepted = [];
        accepted.current.forEach((rec) => {
            const newDoc = documents.find((x) => x.clientId === rec.clientId);
            if (newDoc === null || newDoc === void 0 ? void 0 : newDoc.url) {
                log.log('Found document in store ', newDoc);
                updateFn(newDoc, rec);
            }
            else if (!newDoc) {
                newAccepted.push(rec);
            }
        });
        accepted.current = newAccepted;
        if (accepted.current.length > 0) {
            if (checkRecordsCount.current < 240) { // wait up to 2 minutes
                setTimeout(() => {
                    setForceRender(!forceRender);
                }, 1000);
            }
            else {
                dialogAlert('It appears there was an issue uploading your attachment', 'The upload timed out, you can try again.  You may want to check your network connection', noop_1.default, ['Got it']);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        checkRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceRender]);
    const onUpload = (acceptedFiles) => {
        //
        // upload files to QCS
        //
        log.log('UPLOAD', acceptedFiles);
        if (acceptedFiles.length > 0) {
            acceptedFiles.forEach((rec) => {
                // eslint-disable-next-line no-param-reassign
                rec.clientId = (0, uuid_1.v4)().toUpperCase();
                const newDoc = (0, documentsTypes_1.mkDocument)({
                    name: rec.name,
                    documentSize: rec.size,
                    clientId: rec.clientId,
                    contentType: rec.type,
                });
                // @ts-expect-error: Argument of type '"updateFn"' is not assignable to parameter of type 'keyof DocumentProps'.
                newDoc.set('updateFn', updateFn);
                log.log('Create Document ', newDoc, acceptedFiles);
                setImagesLoading(imagesLoading.concat([{ isLoading: true, document: newDoc }]));
                dispatch(actions.createDocument(newDoc));
                accepted.current = acceptedFiles;
                checkRecords(true);
            });
        }
    };
    const onDrop = (acceptedFiles) => {
        if (acceptedFiles.length + accepted.current.length > MAX_TX_ATTACHMENTS) {
            dialogAlert('Too many attachments', `Sorry, you can only add ${MAX_TX_ATTACHMENTS} items per transaction.`, noop_1.default, ['Got it'], 'warning');
        }
        else {
            onUpload(acceptedFiles);
        }
    };
    const deleteFileEntry = (id) => {
        const document = documents.find((x) => x.id === id);
        dialogAlert('Delete Attachment', `This will delete the attachment ${document ? document.name : UNAVAILABLE_NAME}.  Are you sure?`, (retObj) => {
            if (retObj.btnPressed === 'Delete') {
                // dispatch(actions.deleteDocument({ id }));  // leaves it orphaned, not cleaning up unused document id's
                // delete it from the transactions attachments list
                // create a new attachments array for the transaction
                // @ts-expect-error: Argument of type 'DocumentType[]' is not assignable to parameter of type 'ConcatArray<never>'.
                const attachments = [].concat(txnAttachments.current || []);
                const docIndex = attachments.findIndex((x) => x.id === id);
                if (docIndex >= 0) {
                    attachments.splice(docIndex, 1);
                }
                txnAttachments.current = attachments;
                props.onChange(attachments, false); // do an autosave in this case
            }
        }, ['Cancel', 'Delete'], 'delete');
    };
    const clickPic = (file) => {
        if (file.url !== UNAVAILABLE) {
            window.open(file.url, '_blank');
        }
    };
    const imagesToDisplay = images.concat(imagesLoading);
    const showGeneralLoading = imagesToDisplay.length === 0 && images.length > 0;
    return (<div>
      <styledComponents_1.ModalDocDiv autoFocus>
        <div className={classes.boxDiv}>
          <Typography_1.default className={classes.attachmentTypography}>
            Attachments
          </Typography_1.default>

          <div className="dropzone" id={props.id}>
            <react_dropzone_1.default onDrop={onDrop} accept="app/*, image/*, application/*, text/*">
              {({ getRootProps, getInputProps }) => (<styledComponents_1.DropzoneStyled className="custom" {...getRootProps()}>
                  <input {...getInputProps()}/>
                  <CloudUpload_1.default />
                  <Typography_1.default className={classes.attachTitle} variant="subtitle2">
                    Upload
                  </Typography_1.default>
                </styledComponents_1.DropzoneStyled>)}
            </react_dropzone_1.default>
          </div>
        </div>
        <div className={classes.previewWrapper}>
          {showGeneralLoading &&
            <CircularProgress_1.default size={32} color="primary"/>}
          <styledComponents_1.UploadFileList>
            {imagesToDisplay.length > 0 &&
            imagesToDisplay.map((f, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`${f.name}${index}`}>
                  {/* @ts-expect-error : The expected type comes from property 'onClick' which is declared here on type 'IntrinsicAttributes & ButtonBaseOwnProps */}
                  <ButtonBase_1.default focusRipple classes={{ root: classes.root }} onClick={f.isLoading ? null : () => clickPic(f)}>
                    {f.isLoading &&
                    <CircularProgress_1.default color="primary"/>}
                    <styledComponents_1.FileName>
                      {f.url === UNAVAILABLE ? UNAVAILABLE_NAME : f.document.name}
                    </styledComponents_1.FileName>
                    {!f.isLoading &&
                    <DeleteForever_1.default className={classes.deleteIcon} onClick={(e) => {
                            e.stopPropagation();
                            deleteFileEntry(f.id);
                        }}/>}
                  </ButtonBase_1.default>
                </li>))}
          </styledComponents_1.UploadFileList>
        </div>
        <styledComponents_1.HiddenInput autoFocus name={props.lastTabName}>
        </styledComponents_1.HiddenInput>
      </styledComponents_1.ModalDocDiv>
    </div>);
};
exports.default = AddAndBrowseDocuments;
